import Authentication from "components/Authentication";
import MainLayout from "components/MainLayout";
import Metadata from "components/Metadata";
import React from "react";

export default function JoinPage() {
  return (
    <MainLayout>
      <Metadata
        title="Get Booked for Bagpiping Gigs | Pipers For Hire"
        description="Join the fastest growing site for bagpipers looking to book more gigs. Get started for free or explore our membership plans for more features."
        url="https://pipersforhire.com/join"
      />
      <h1 className="text-2xl font-bold text-theme-blue">
        Create a Free Account
      </h1>
      <p className="mt-4">
        Getting started with Pipers For Hire is free and takes less than 5
        minutes. Once you have a profile you&apos;ll be eligible to be found for
        bagpiper searches in your area.
      </p>
      <div className="mt-10 grid grid-cols-1 gap-20 sm:mt-20 sm:grid-cols-2 sm:gap-32">
        <ol className="row-start-2 flex flex-col space-y-12 sm:row-start-auto">
          <li>
            <h2 className="text-xl font-semibold text-theme-dark-blue">
              1. Create a profile
            </h2>

            <p className="mt-4">
              Add your best photos, videos, and a brief description to get
              things started. The more complete your profile, the better
              you&apos;ll appear in searches.
            </p>
          </li>

          <li>
            <h2 className="text-xl font-semibold text-theme-dark-blue">
              2. Send quotes
            </h2>

            <p className="mt-4">
              Respond to leads quickly with service quotes.
            </p>
          </li>

          <li>
            <h2 className="text-xl font-semibold text-theme-dark-blue">
              3. Get booked!
            </h2>

            <p className="mt-4">
              Book local gigs and get paid quickly with invoicing and payment
              done through Pipers For Hire. Get deposits paid out in 1-2
              business days and leave out the admin work of following up with
              clients for the balance. Because payment is handled by the
              platform, it&apos;s guaranteed!
            </p>
          </li>
        </ol>

        <div className="row-start-1 sm:row-start-auto">
          <Authentication signup={true} />
        </div>
      </div>
    </MainLayout>
  );
}
